<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000" top-wrapper-classes="bottom-line md:shadow-none">
            <template #top>
                <p class="font-bold text-center mb-2">You are almost done.</p>
                <p class="text-center mb-3.5 leading-7 text-base font-medium">{{ user.first_name }}</p>
            </template>
            <template #bottom-left>
                <div>Name</div>
                <div v-if="false">Amount</div>
                <div>Email</div>
            </template>
            <template #bottom-right>
                <div v-text="user.full_name"/>
                <!-- <div>{{ loan.amount | money(0) }}</div> -->

                <!-- Hide Amount field for leadgen users -->
                <div v-if="false">
                    <select
                        v-model="selectedAmount" 
                        name="" 
                        id="" 
                        class="amount-select rounded w-full text-[#000] focus:outline-none appearance-none bg-transparent max-w-32 pl-4 border border-gray-100">
                        <option 
                            v-for="(amount, key) in getDefaultAmounts" 
                            :value="key" 
                            :key="key">
                            {{ amount | money(0) }}
                        </option>
                    </select>
                </div>
                <div v-text="user.email"/>
            </template>
            <template #bottom-bottom>
                <div class="bg-gray-100 rounded-full w-full">
                    <div class="bg-success rounded-full p-0.5 pt-1 pl-3 text-white text-xs font-bold" :style="{ 'width': '93%' }">Progress: 97% complete</div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-500" footer>

            <!--            <template #title>-->
            <!--                Consents-->
            <!--            </template>-->

            <template #main>
                <!--                <div class="flex text-base leading-relaxed mt-5">-->
                <!--                    <input id="adult_check"-->
                <!--                           name="adult_check"-->
                <!--                           class="bg-gray-50 border-gray-300 rounded"-->
                <!--                           type="checkbox"-->
                <!--                           :value="adult_check"-->
                <!--                           :checked="adult_check"-->
                <!--                           @change="adult_check = $event.target.checked" />-->
                <!--                    <label for="adult_check" class="pl-3.5">-->
                <!--                        I consent to the <a class="text-black" href="/pages/electronic-consent" target="_blank">Electronic Communications Consent Policy,</a>-->
                <!--                        and I have read and agree to the <a class="text-black" href="/pages/terms-of-use" target="_blank">Terms of Use</a> and <a class="text-black" href="/pages/privacy-policy" target="_blank">Privacy Policy.</a>-->
                <!--                    </label>-->
                <!--                </div>-->

                <!--                <div class="flex text-base leading-relaxed mt-5">-->
                <!--                    <input id="bankruptcy_check"-->
                <!--                           name="bankruptcy_check"-->
                <!--                           class="bg-gray-50 border-gray-300 rounded"-->
                <!--                           type="checkbox"-->
                <!--                           :value="bankruptcy_check"-->
                <!--                           @change="bankruptcy_check = $event.target.checked" />-->
                <!--                    <label for="bankruptcy_check" class="pl-3.5">-->
                <!--                        I am not currently a debtor under any proceeding in bankruptcy, and have no intention to file-->
                <!--                        a petition for relief under any chapter of the United States bankruptcy code and I do not-->
                <!--                        intend to use the proceeds of the loan to obtain counsel of file a petition for relief.-->
                <!--                    </label>-->
                <!--                </div>-->

                <button @click.prevent="accept()" type="submit" class="w-full shadow-action font-semibold text-lg bg-action rounded text-white py-3" :class="{ 'opacity-50 cursor-not-allowed': ! adult_check || ! bankruptcy_check }">
                    <template v-if="! loading">
                        Continue
                    </template>
                    <template v-else>
                        <i class="fa fa-circle-notch fa-spin" />
                    </template>
                </button>

                <p class="mt-4 text-center">Contact us at <a data-testid="support-email" :href="$root.app.mailtoSupport" target="_blank">{{ $root.app.support_email }}</a></p>
            </template>

        </app-body>
    </app-wrapper>
</template>

<script>
import AppLogo from './../../../components/AppLogo';
export default {
    mixins: [
        require('../../../mixins/InteractsWithGtag').default,
        require("../../../mixins/AddTagToLoan").default,
        require("../../../mixins/GetLoansAmountsByState").default,
    ],
    components: {
        AppLogo
    },
    props: {
        user: {},
        loan: {},
    },

    data() {
        return {
            loading: false,
            adult_check: true,
            bankruptcy_check: true,
            gTagPageName: 'consents-account',
            selectedAmount: "",
            originalAmount: "",
        }
    },

    mounted() {
        this.selectedAmount = this.originalAmount = this.loan.amount;
    },

    methods: {
        accept() {
            this.loading = true;

            this.$http.post(`/signup/welcome/${this.loan.id}`, {
                adult_check: this.adult_check,
                bankruptcy_check: this.bankruptcy_check,
                selected_amount: this.selectedAmount,
            }).then(({data}) => {
                this.loading = false;

                window.location.reload();
            }).catch(() => {
                this.loading = false
            });
        },
    },
}
</script>
